<template>
  <div>
    {{ data.priceBuy }} {{ data.currencyBuy && data.currencyBuy.code }} <template v-if="data.incotermBuy">({{ data.incotermBuy.name }})</template>
  </div>
</template>

<script>

export default {
  props: ['data', 'index', 'column'],
}
</script>
